/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { BrowserStorageEditor } from './BrowserStorageEditor';
import { Editor } from './Editor';
import { SharedPreferenceMode } from './SharedPreferenceMode';
import { Storage } from './Storage';

// TODO: We need to implement the shared preference change listener using the
// `TivoSubscriptionModel`.
export class SharedPreferences {
    private mSharedData: { [key: string]: [value: any] } | Object;

    private mName: string;

    private mEditor: Editor;

    public constructor(
        name: string,
        mode: SharedPreferenceMode = SharedPreferenceMode.SESSION_STORAGE,
    ) {
        this.mName = name;
        let oStoredData = Storage.getInstance().getItem(this.mName);

        switch (mode) {
            case SharedPreferenceMode.LOCAL_STORAGE:
                this.mEditor = new BrowserStorageEditor(this.mName, true);
                break;

            case SharedPreferenceMode.SESSION_STORAGE:
                this.mEditor = new BrowserStorageEditor(this.mName);
                oStoredData = Storage.getInstance(Storage.StorageType.SESSION_STORAGE).getItem(
                    this.mName,
                );
                break;
            case SharedPreferenceMode.FILE_SYSTEM:
            default:
                throw new Error('Shared preference mode is not supported.');
        }

        this.mSharedData = oStoredData || {};
    }

    public edit(): Editor {
        return this.mEditor;
    }

    public getBoolean(key: string): boolean {
        return this.mSharedData[key] as boolean;
    }

    public getJson(key: string): JSON {
        return this.mSharedData[key] as JSON;
    }

    public getNumber(key: string): number {
        return this.mSharedData[key] as number;
    }

    public getString(key: string): string {
        return this.mSharedData[key] as string;
    }
}
